module.exports = {"devEnv":false,"prodEnv":true,"refreshTokenTime":60000,"serverPort":"localhost","serverUrl":"https://www.dot.nd.gov/dot/techcert","clientHomeUrl":"https://www.dot.nd.gov/dot/techcert","version":"2024-01-19-prod-tech-cert"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 13
// module chunks = 0